import { gql } from "@apollo/client";

import { PROGRAM_HISTORY_INFO, PROGRAM_HISTORY_WITH_SPECIALIST } from "@/graphql-client/fragments";

export const GET_TREATMENT_HISTORY = gql`
  query GetTreatmentHistory($accountId: Int!) {
    treatmentHistory: programHistory(account_id: $accountId) {
      ...ProgramHistoryWithSpecialist
    }
  }
  ${PROGRAM_HISTORY_WITH_SPECIALIST}
`;

export const GET_LATEST_PROGRAM = gql`
  query GetLatestProgram($accountId: Int!) {
    getLatestProgram(account_id: $accountId) {
      ...ProgramHistoryInfo
    }
  }
  ${PROGRAM_HISTORY_INFO}
`;

/** Patient Info treatment table only — minimal fields, separate query name from GetTreatmentHistory. */
export const GET_PATIENT_TREATMENT_HISTORY_TABLE = gql`
  query GetPatientTreatmentHistoryTable($accountId: Int!) {
    treatmentHistory: programHistory(account_id: $accountId) {
      id
      program_type
      round
      start_date
      end_date
      status
      specialist {
        id
        firstName
      }
    }
  }
`;
